export default {"src":"/_next/static/media/visa-document.1a3f916d.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};